export const carti = [
  {
    titlu: "Ghid Promovare Partid De Către Membri",
    autor: "PRDP",
    pagini: "6",
    type: "HTML",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/ghid_prdp_membri_voluntari_promovare.html",
    categorie: "Comunicare"
  },
  {
    titlu: "România Pe Sub Mână",
    autor: "David Banu",
    pagini: "197",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/romania-pe-sub-mana.pdf",
    categorie: "Politică & Istorie"
  },
  {
    titlu: "Nu tot ei! România în ghearele imposturii",
    autor: "Valeriu Nicolae",
    pagini: "233",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/nu-tot-ei.pdf",
    categorie: "Politică"
  },
  { 
    titlu: "Iluzia Guvernării: De la Promisiuni Grandioase la Realități Amare",
    autor: "Alin Mureșanu",
    pagini: "5",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/iluzia-guvernarii-muresanu.pdf",
    categorie: "Politică"
  },
  {
    titlu: "Perspective în zbor: Analiza lunii Aprilie cu Alin Mureșanu",
    autor: "Alin Mureșanu",
    pagini: "11",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/interviu-aprilie-alin-muresanu.pdf",
    categorie: "Interviu"
  },
  {
    titlu: "Constituția României",
    autor: "Statul Român",
    pagini: "72",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/constitutia-romaniei.pdf",
    categorie: "Politică"
  },
  {
    titlu: "De ce este România altfel",
    autor: "Lucian Boia",
    pagini: "127",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/de-ce-este-romania-altfel.pdf",
    categorie: "Istorie"
  },
  {
    titlu: "Cum să vorbim în public",
    autor: "Dale Carnegie",
    pagini: "186",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/cum-sa-vorbim-in-public.pdf",
    categorie: "Dezvoltare Personală"
  },
  {
    titlu: "Înconjurat de idioți",
    autor: "Thomas Erikson",
    pagini: "300",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/inconjurat-de-idioti.pdf",
    categorie: "Dezvoltare Personală"
  },
  {
    titlu: "Plan Național PRDP",
    autor: "PRDP",
    pagini: "47",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/plan-national-prdp.pdf",
    categorie: "Politică"
  },
  {
    titlu: "Secretele comunicării",
    autor: "Larry King",
    pagini: "156",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/secretele-comunicarii.pdf",
    categorie: "Comunicare"
  },
  {
    titlu: "Diplomația",
    autor: "Henry Kissinger",
    pagini: "889",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/diplomatia.pdf",
    categorie: "Politică"
  },
  {
    titlu: "Arta narațiunii politice",
    autor: "Philip Seargeant",
    pagini: "234",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/arta-naratiunii-politice.pdf",
    categorie: "Politică"
  },
  {
    titlu: "O istorie politică a lumii",
    autor: "Jonathan Holslag",
    pagini: "267",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/o-istorie-politica-a-lumii.pdf",
    categorie: "Istorie"
  },
  {
    titlu: "Teoria comunicării",
    autor: "Irina Stănciugelu",
    pagini: "440",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/teoria-comunicarii.pdf",
    categorie: "Comunicare"
  },
  {
    titlu: "Mapă Prezentare PRDP",
    autor: "PRDP",
    pagini: "26",
    type: "PDF",
    url: "https://pub-ae3c26fbbd814c3d81889e6564d3a73d.r2.dev/mapa-prezentare-prdp.pdf",
    categorie: "Politică"
  }
];
